import { c as _c } from "react/compiler-runtime";
import { Button, Link, Popover, Text } from '@chakra-ui/react';
import { UserAccessGateProps } from '@src/components/sco/UserAccessGate';
import { LockIcon } from '@src/components/sco/icons';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { usePathname } from 'next/navigation';
import React from 'react';
export const ButtonCTA = props => {
  const $ = _c(13);
  useCurrentUser();
  const pathname = usePathname();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      placement: "bottom"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.buttonProps) {
    t1 = props.buttonProps || {};
    $[1] = props.buttonProps;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LockIcon />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = props.buttonProps?.children || props.buttonProps?.title || "CTA Label";
  let t4;
  if ($[4] !== t1 || $[5] !== t3) {
    t4 = <Popover.Trigger asChild={true}><Button variant="cta" width="full" {...t1}>{t2}{t3}</Button></Popover.Trigger>;
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Popover.Arrow bgColor="colorPalette.bg" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = `${pathname}?prompt=login`;
  let t7;
  if ($[8] !== t6) {
    t7 = <Popover.Positioner><Popover.Content bgColor="colorPalette.bg" boxShadow="0 0 3px rgba(0,0,0,.25)" width="auto">{t5}<Popover.Body padding="0.5em 1em"><Text fontSize="0.8em" textAlign="center">{"Already a member?"}{" "}<Link asChild={true} fontWeight="bold" variant="underline"><NextLink href={t6}>Login</NextLink></Link></Text></Popover.Body></Popover.Content></Popover.Positioner>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t4 || $[11] !== t7) {
    t8 = <Popover.Root positioning={t0}>{t4}{t7}</Popover.Root>;
    $[10] = t4;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};